if ($('[data-trhover]').length) {
    $('.tr_hover').css({
        height: $('[data-trhover]')[0].offsetHeight + 'px',
    });
}

$('[data-trhover]').hover(function () {
    var closestCvTable = $(this).closest('[data-trhover-container]');

    closestCvTable.attr('style', `--cv-tr-height:${this.offsetHeight}px; --cv-tr-top:${this.offsetTop}px`);
});

$('[data-trhover-container]').mousemove(function() {
    const trHovered = $(this).find('[data-trhover].hover');

    if (trHovered.length) {
        $(this).attr('style', `--cv-tr-height:${trHovered[0].offsetHeight}px; --cv-tr-top:${trHovered[0].offsetTop}px`);
    }
})
